import { cn } from '@/new/lib/utils';

export function PageContainer({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={cn('px-8 text-sm', className)}>{children}</div>;
}
